import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconArrowUp: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M7.406 15.422l-1.406-1.406 6-6 6 6-1.406 1.406-4.594-4.594z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconArrowUp;
